export default __webpack_public_path__ + "static/BZ_COBERTURADC_EP_R00-1_Pgina_46-a057f1ab8662958ff2c751cb21fe2452.jpg";